<template>
  <div class="content-430">
    <div class="class-form-head">适用学校</div>
    <div class="class-form-content">
      <div class="head-line">
        <span>已选{{ pageInfo.total }}个学校适用，如已使用其他方案的学校不会在下方列出</span>
        <Button v-if="isSet" type="primary" @click="handleAddSchool">添加适用学校</Button>
      </div>
      <Table :columns="schoolColumn" :data="dataSchool" :loading="loadingSchool" border>
        <template slot="action" slot-scope="{ row }">
          <span class="click-btn-430" @click="handleDelSchool(row.schoolId)">删除</span>
        </template>
      </Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          show-sizer
          show-elevator
          show-total
          class="text-right mb-5 mt-5"
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          :page-size-opts="pageSizeOpts"
          @on-change="handlePage"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
    </div>
    <SelectSchoolDrawer ref="selectSchoolDrawer" :plan-id="planId" @refresh="handlePage(1)"></SelectSchoolDrawer>
  </div>
</template>
<script>
import SelectSchoolDrawer from './SelectSchoolDrawer';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    SelectSchoolDrawer
  },
  props: {
    planId: {
      type: String,
      default: ''
    },
    isSet: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      schoolColumn: [
        {
          title: '学校名称',
          key: 'schoolName',
          minWidth: 200
        }, {
          title: '区域',
          key: 'areaName',
          minWidth: 200
        }
      ],
      dataSchool: [],
      loadingSchool: false,
      schoolTotal: 0,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pageSizeOpts: [10, 20, 50, 100]
    };
  },
  watch: {
    isSet: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.schoolColumn.push({
            title: '操作',
            slot: 'action',
            minWidth: 200
          });
        }
      },
      immediate: true
    }
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    handleAddSchool() {
      this.$nextTick(() => {
        this.$refs.selectSchoolDrawer.open();
      });
    },
    // 点击分页页码
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getSchoolList();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getSchoolList();
    },
    // 获取学校列表
    async getSchoolList() {
      const params = {
        planId: this.planId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      this.loadingSchool = true;
      const res = await orderCenterApi.getListSchRelPlanApi(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        this.pageInfo.total = +res.message.total;
        this.dataSchool = res.message.list ? res.message.list : [];
      }
    },
    // 删除学校
    handleDelSchool(schoolId) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除吗？删除后不可恢复',
        onOk: () => {
          this.delSchoolTrue(schoolId);
        }
      });
    },
    async delSchoolTrue(schoolId) {
      const params = {
        planId: this.planId,
        schoolId
      };
      const res = await orderCenterApi.delListSchRelPlanApi(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        this.getSchoolList();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-wrap {
  padding: 16px 0;
  text-align: right;
}
.class-form-content{
  width: 80%;
}
.head-line{
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
